// Sizes.
// -----------------------------------------------------------------------------
// Valores por defecto.
export const ICONBUTTON_DEFAULT_DISABLED = false;
export const ICONBUTTON_DEFAULT_MODE = 'light';
export const ICONBUTTON_DEFAULT_SCHEME = 'neutral';
export const ICONBUTTON_DEFAULT_SIZE = 's';
export const ICONBUTTON_DEFAULT_VARIANT = 'hard';
// Mapping
export const ICONBUTTON_ICON_SIZES = {
    s: 'xl',
    xs: 'l',
    '2xs': 'l'
};
export const ICONBUTTON_PADDING_SIZES = {
    s: {
        horizontal: 'l',
        vertical: 'l'
    },
    xs: {
        horizontal: 'm',
        vertical: 'm'
    },
    '2xs': {
        horizontal: 's',
        vertical: 'xs'
    }
};
//# sourceMappingURL=IconButton.constants.js.map